import PartnershipCurrentIBProgramsPage from './PartnershipCurrentIBProgramsPage';

export default PartnershipCurrentIBProgramsPage;
